import { navigate } from "./tixxt-router";
import { frontendByLocation } from "../components/layout/TixxtContent";
import queryClient from "./queryClient";

// Way back from the legal-text confirmation (#104): so the user lands back
// WHERE THEY WERE after confirming (and not on the start page), the
// server-side gate redirect appends the origin URL as ?return_to to the
// /legal URL. That guarantees it is correct per tab/webview; sessionStorage
// is no option because the app's tab webviews share it.

// Only allow relative paths (no open redirect via ?return_to). Backslashes
// are rejected too: browsers normalize "\" to "/", so "/\evil.com" would
// resolve protocol-relative off-site.
function sanitizeTarget(target: string | null) {
  if (
    target &&
    target.startsWith("/") &&
    !target.startsWith("//") &&
    !target.includes("\\")
  )
    return target;
  return null;
}

// Navigates back to the remembered page after the legal texts were confirmed
// (falling back to the start page). No Turbo.visit for SPA routes: TixxtContent
// intercepts it and, inside the app, hands it back to the native session as
// navigateInApp, whose performVisit ends up in the same interception again —
// the visit goes in circles. SPA targets therefore go through the router
// directly (replace bypasses the bridge branch), only Turbo targets use a
// real Turbo visit.
export function navigateAfterLegalConfirmation() {
  const fromUrl = new URLSearchParams(window.location.search).get("return_to");
  let target = sanitizeTarget(fromUrl);
  if (!target || target.split("?")[0] === "/legal") target = "/";

  // While the gate was active, API requests failed with 403; the queries
  // would otherwise stay stuck in their error state ("failed to load")
  // instead of refetching.
  void queryClient.resetQueries();

  // Clear cached legal snapshots: this recovery bypasses the Turbo cache, so
  // restoration visits (e.g. tab switches in the app) would keep flashing
  // the confirmation page.
  (window as { Turbo?: { cache?: { clear(): void } } }).Turbo?.cache?.clear();

  if (frontendByLocation(target) === "turbo") {
    const turbo = (window as { Turbo?: { visit(url: string): void } }).Turbo;
    if (turbo) turbo.visit(target);
    else window.location.assign(target);
  } else {
    navigate(target, { replace: true });
  }
}
